import { createVNode as _createVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "user-import-comp" }
const _hoisted_2 = /*#__PURE__*/_createVNode("p", null, "View all job tickets for bulk user operations.", -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("h3", null, "Import Jobs", -1)
const _hoisted_4 = { class: "scrollable job-container" }
const _hoisted_5 = { style: {"font-size":"18px"} }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Status: ")
const _hoisted_7 = {
  key: 0,
  class: "green"
}
const _hoisted_8 = {
  key: 1,
  class: "red"
}
const _hoisted_9 = {
  key: 2,
  class: "yellow"
}
const _hoisted_10 = { class: "margin-vert-small" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = {
  key: 0,
  style: {"font-size":"16px"}
}
const _hoisted_13 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_14 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_15 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_16 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_17 = {
  key: 1,
  style: {"width":"50%"}
}
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" Errors: ")
const _hoisted_19 = /*#__PURE__*/_createVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_divider = _resolveComponent("el-divider")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_el_divider),
    _hoisted_3,
    _createVNode("div", _hoisted_4, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.importJobs, (job) => {
        return (_openBlock(), _createBlock("div", {
          class: "scrollable job-card",
          key: job._id
        }, [
          _createVNode("div", _hoisted_5, [
            _hoisted_6,
            (job.status === 'completed')
              ? (_openBlock(), _createBlock("span", _hoisted_7, "Completed"))
              : _createCommentVNode("", true),
            (job.status === 'failed')
              ? (_openBlock(), _createBlock("span", _hoisted_8, "Failed"))
              : _createCommentVNode("", true),
            (job.status === 'importing')
              ? (_openBlock(), _createBlock("span", _hoisted_9, "Importing"))
              : _createCommentVNode("", true)
          ]),
          _createVNode("div", _hoisted_10, [
            _createVNode("div", null, " Start Time: " + _toDisplayString(_ctx.convertDateString(job.date_started, _ctx.userPrefs?.timezone)), 1),
            (job.date_stopped)
              ? (_openBlock(), _createBlock("div", _hoisted_11, " End Time: " + _toDisplayString(_ctx.convertDateString(job.date_stopped, _ctx.userPrefs?.timezone)), 1))
              : _createCommentVNode("", true)
          ]),
          (job.completedInfo)
            ? (_openBlock(), _createBlock("div", _hoisted_12, [
                _createTextVNode(_toDisplayString(job.completedInfo.num_added) + " Users Added ", 1),
                _hoisted_13,
                _createTextVNode(" " + _toDisplayString(job.completedInfo.num_updated) + " Users Updated ", 1),
                _hoisted_14,
                _createTextVNode(" " + _toDisplayString(job.completedInfo.num_terminated) + " Users Terminated ", 1),
                _hoisted_15,
                _createTextVNode(" " + _toDisplayString(job.completedInfo.num_rehired) + " Users Rehired ", 1),
                _hoisted_16
              ]))
            : _createCommentVNode("", true),
          (job.error)
            ? (_openBlock(), _createBlock("div", _hoisted_17, [
                _hoisted_18,
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(job.error, (error) => {
                  return (_openBlock(), _createBlock("div", {
                    class: "job-error scrollable",
                    key: error.row.toString() + error.error
                  }, [
                    _createTextVNode(" Row: " + _toDisplayString(error.row) + " ", 1),
                    _hoisted_19,
                    _createTextVNode(" Error: " + _toDisplayString(error.error), 1)
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ]))
      }), 128))
    ])
  ]))
}